import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

export interface VideoQualityLevel {
  index: number;
  height: number;
}

@Component({
  selector: 'app-video-quality-selector',
  standalone: true,
  templateUrl: './video-quality-selector.component.html',
  styleUrl: './video-quality-selector.component.scss',
})
export class VideoQualitySelectorComponent {
  @Input() levels: VideoQualityLevel[] = [];
  @Input() selectedLevel = -1;
  @Input() activeLevel = -1;
  @Input() manualSelectionAvailable = false;
  @Output() qualitySelected = new EventEmitter<number>();

  showMenu = false;

  get indicatorLabel(): string {
    const selected = this.levels.find((level) => level.index === this.selectedLevel);
    if (selected) {
      return `${selected.height}p`;
    }

    const active = this.levels.find((level) => level.index === this.activeLevel);
    return active ? `Auto (${active.height}p)` : 'Auto';
  }

  toggleMenu(): void {
    if (!this.manualSelectionAvailable) return;
    this.showMenu = !this.showMenu;
  }

  selectLevel(level: number): void {
    this.qualitySelected.emit(level);
    this.showMenu = false;
  }

  @HostListener('document:click', ['$event'])
  closeOnOutsideClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (this.showMenu && !target.closest('.quality-selector')) {
      this.showMenu = false;
    }
  }
}
